const Brand_Logo_1 = () => {
  return (
    <div className="col-span-3 self-end mb-20">
      <h1 className="font-[600] text-3xl ">Brand Logo</h1>
    </div>
  );
};

export default Brand_Logo_1;
